import React, {ReactNode} from "react";
import styles from "./Typography.module.css";
import clsx from "clsx";

type GrayScale =
    | "black"
    | "gray-42"
    | "gray-61"
// | "gray-85"
// | "gray-97"
// | "white"
    ;

type LineHeight = 1 | 1.2 | 1.43 | 1.5;

interface TextStyleProps {
    color?: GrayScale;
    lineHeight?: LineHeight;
}

interface TextProps extends TextStyleProps {
    children: ReactNode;
}

function getLineHeightStyles(lineHeight?: LineHeight) {
    return clsx({
        [styles.lineHeight120]: lineHeight === 1.2,
        [styles.lineHeight143]: lineHeight === 1.43,
        [styles.lineHeight150]: lineHeight === 1.5
    });
}

function getColorStyles(color?: GrayScale) {
    return clsx({
        [styles.textColorBlack]: color === "black" || !color,
        [styles.textColorGray42]: color === "gray-42",
        [styles.textColorGray61]: color === "gray-61"
    });
}

function getTextProps(className: string, {color, lineHeight}: TextStyleProps) {
    return clsx(
        className,
        getColorStyles(color),
        getLineHeightStyles(lineHeight)
    );
}

export const Title40 = ({children, ...styleProps}: TextProps) => (
    <span className={getTextProps(styles.title40, styleProps)}>{children}</span>
);

export const Title24 = ({children, ...styleProps}: TextProps) => (
    <span className={getTextProps(styles.title24, styleProps)}>{children}</span>
);

export const Text16 = ({children, ...styleProps}: TextProps) => (
    <span className={getTextProps(styles.text16, styleProps)}>{children}</span>
);

export const Text14 = ({children, ...styleProps}: TextProps) => (
    <span className={getTextProps(styles.text14, styleProps)}>{children}</span>
);

export const TextPrimary = ({children, ...styleProps}: TextProps) => (
    <span className={getTextProps(styles.textColorPrimary, styleProps)}>{children}</span>
);

interface LabelProps extends TextStyleProps {
    children: ReactNode;
    variant?: "normal" | "medium";
}

export function Label14({children, variant, ...styleProps}: LabelProps) {
    const classes = clsx(
        getTextProps(styles.label14, styleProps),
        {
            // [styles.label14normal]: variant === "normal",
            [styles.label14medium]: variant === "medium"
        }
    );

    return (
        <span className={classes}>{children}</span>
    );
}

export function Label12({children, variant, ...styleProps}: LabelProps) {
    const classes = clsx(
        getTextProps(styles.label12, styleProps),
        {
            // [styles.label12normal]: variant === "normal",
            [styles.label12medium]: variant === "medium"
        }
    );

    return (
        <span className={classes}>{children}</span>
    );
}
